module.exports = __webpack_public_path__ + "static/media/events.6655aed7.svg";